/** Stash invite code from /invite/:code so signup can attribute the inviter. */

export const MEMBER_INVITE_CODE_STORAGE_KEY = 'bravos.member_invite_code';

export function stashMemberInviteCode(code: string): void {
  if (typeof window === 'undefined') return;
  const trimmed = code.trim();
  if (trimmed.length < 4 || trimmed.length > 64) return;
  try {
    window.localStorage.setItem(MEMBER_INVITE_CODE_STORAGE_KEY, trimmed);
  } catch {
    /* private mode / quota — attribution best-effort */
  }
}

export function peekMemberInviteCode(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const v = window.localStorage.getItem(MEMBER_INVITE_CODE_STORAGE_KEY);
    const trimmed = (v || '').trim();
    if (trimmed.length < 4 || trimmed.length > 64) return null;
    return trimmed;
  } catch {
    return null;
  }
}

export function clearMemberInviteCode(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(MEMBER_INVITE_CODE_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
